import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'excerpt',
    standalone: false
})
export class ExcerptPipe implements PipeTransform {

  transform(value: string, maxlength = 140, cutOff = '...', keepWord = false): any {
    value = this.stripTags(value);

    if(value.length <= maxlength) {
      return value;
    }


      if(keepWord) {
        value = value.substr(0, maxlength + 1);
        const lastSpace = value.lastIndexOf(' ')
        if(lastSpace) {
          value = value.substr( 0, lastSpace);
          value = value.trimEnd();
          value +=  cutOff;
        }
      } else {
        value = value.substr( 0, maxlength);
        value = value.trimEnd();
        value +=  cutOff;
      }


    return value;
  }

  private stripTags(value: string) {
    return value.replace(/(<([^>]+)>)/ig, "");
  }
}
